import { Subscription } from 'rxjs';
import { viewDocument } from 'src/app/controls/functions/functions';
import { LocationComponent } from 'src/app/modules/shared/location/location.component';
import { jsonDeepParse, prepareValidationScript } from 'src/app/functions/shared-functions';
import { MatDialog } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormArray, UntypedFormBuilder } from '@angular/forms';
import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { ConfirmationComponent } from 'src/app/modules/shared/confirmation/confirmation.component';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { ProfileSettingsService } from 'src/app/services/shared/profile-settings/profile-settings.service';

@Component({
  selector: 'app-ext-fields',
  templateUrl: './ext-fields.component.html',
  styleUrls: ['./ext-fields.component.scss']
})
export class ExtFieldsComponent implements OnInit, OnChanges {

  @Input() form_group: UntypedFormGroup;
  @Input() form_control;
  @Input() data = [];
  @Input() options = [];
  @Input() masters: any = {}
  isEdit = 0;
  currentField: any = {};
  fieldForm: UntypedFormGroup = new UntypedFormGroup({
    attachLabel: new UntypedFormControl(null),
    attachValue: new UntypedFormControl(null),
    attachVisible: new UntypedFormControl(null),
    date1Label: new UntypedFormControl(null),
    date1Value: new UntypedFormControl(null),
    date1Visible: new UntypedFormControl(null),
    date2Label: new UntypedFormControl(null),
    date2Value: new UntypedFormControl(null),
    date2Visible: new UntypedFormControl(null),
    fieldCode: new UntypedFormControl(null),
    mandatory: new UntypedFormControl(null),
    noChanges: new UntypedFormControl(null),
    refLabel: new UntypedFormControl(null),
    refType: new UntypedFormControl(null),
    validationRegExp: new UntypedFormControl(null),
    value: new UntypedFormControl(null),
    tableId: new UntypedFormControl(null),
    cssClass: new UntypedFormControl(null)
  })
  uploadedStatus = 1;
  @Input() checkListForm: UntypedFormGroup;
  items: UntypedFormArray;
  masters_sub: Subscription;

  constructor(
    private notification: NotificationService,
    private dialog: MatDialog,
    private formBuilder: UntypedFormBuilder,
    private settings: ProfileSettingsService
  ) { }

  ngOnInit(): void {
    // this.masters_sub = this.settings.getMastersSub().subscribe(res => {
    //   if (res && res['data'] && res['data'].sharedMasterData && res['data'].sharedMasterData.extendedMasterList) {
    //     this.masters = jsonParse(res['data'].sharedMasterData.extendedMasterList)
    //     console.log(this.masters)
    //   }
    // })
  }
  addItem(data): void {
    this.items = this.checkListForm.get('items') as UntypedFormArray;
    this.items.push(this.createItem(data));
  }
  ngOnDestroy(): void {
    if (this.masters_sub) {
      this.masters_sub.unsubscribe();
    }
  }
  createItem(data?): UntypedFormGroup {
    return this.formBuilder.group({
      attachLabel: new UntypedFormControl(data.attachLabel),
      attachValue: new UntypedFormControl(data.attachValue),
      attachVisible: new UntypedFormControl(data.attachVisible),
      date1Label: new UntypedFormControl(data.date1Label),
      date1Value: new UntypedFormControl(data.date1Value),
      date1Visible: new UntypedFormControl(data.date1Visible),
      date2Label: new UntypedFormControl(data.date2Label),
      date2Value: new UntypedFormControl(data.date2Value),
      date2Visible: new UntypedFormControl(data.date2Visible),
      fieldCode: new UntypedFormControl(data.fieldCode),
      mandatory: new UntypedFormControl(data.mandatory),
      noChanges: new UntypedFormControl(data.noChanges),
      refLabel: new UntypedFormControl(data.refLabel),
      refType: new UntypedFormControl(data.refType),
      validationRegExp: new UntypedFormControl(data.validationRegExp),
      value: new UntypedFormControl(data.refType == 9 ? this.prepareMultiLineText(data.value) : data.value, [data.mandatory ? Validators.required : Validators.nullValidator]),
      tableId: new UntypedFormControl(data.tableId),
      cssClass: new UntypedFormControl(data.cssClass)
    });
  }
  ngOnChanges(ev) {
    console.log(ev)
    if (ev && ev.data) {
      this.data = jsonDeepParse(ev.data.currentValue);
      if (this.data && this.data.length) {
        this.checkListForm = this.formBuilder.group({
          items: this.formBuilder.array([])
        });
        this.data.forEach(field => {
          field['validationScript'] = prepareValidationScript(field['validationRegExp']);
          console.log(field)
          this.addItem(field)
        })
        if (this.items) {
          this.items.valueChanges.subscribe(res => {
            console.log(res)
            if (res) {
              this.form_group.get([this.form_control]).patchValue(res);
            }
          })
        }
        this.options = [...this.data]
      }
      else {
        this.options = []
      }
    }
    if (ev && ev.masters) {
      this.masters = ev.masters.currentValue
    }
  }
  checkboxEvent(ev, form_group) {
    if (ev) {
      if (form_group && form_group.get(['value'])) {
        form_group.get(['value']).patchValue(ev.checked ? 1 : 0)
      }
    }
  }

  prepareMultiLineText(text) {
    if (text && text != '') {
      if (typeof text != 'string') {
        text = text.toString();
      }
      text = text.replace(/\\n/g, '\r\n');
      return text
    }
    else {
      return ''
    }
  }

  editField(field, type?) {
    if (type) {
      this.isEdit = 1;
      if (field) {
        this.currentField = field;
        if (field.validationScript && field.validationScript != '') {
          // field = prepareValidationScript(field)
          // setValidators(field, this.fieldForm);
        }
        else if (field.mandatory && field.refType != 1) {
          this.fieldForm.controls['value'].setValidators([Validators.required])
          this.fieldForm.controls['value'].updateValueAndValidity();
        }
        else {
          this.fieldForm.controls['value'].clearValidators();
          this.fieldForm.controls['value'].updateValueAndValidity();
        }
        this.fieldForm.patchValue(field)
      }
    }
    else {
      if (field && !this.isEdit) {
        this.currentField = field;
        if (field.validationScript && field.validationScript != '') {
          // field = prepareValidationScript(field)
          // setValidators(field, this.fieldForm);
        }
        else if (field.mandatory) {
          this.fieldForm.controls['value'].setValidators([Validators.required])
          this.fieldForm.controls['value'].updateValueAndValidity();
        }
        else {
          this.fieldForm.controls['value'].clearValidators();
          this.fieldForm.controls['value'].updateValueAndValidity();
        }
        this.fieldForm.patchValue(field)
      }
    }

  }
  openAddress(item?) {
    this.dialog.open(LocationComponent, {
      width: "60%",
      data: {
        manual_save: 1,
        values: item.value.value
      }
    }).afterClosed().subscribe(res => {
      if (res) {
        item.controls.value.patchValue(res)
      }
    })
  }
  validStatus(ev) {
    this.uploadedStatus = ev;
  }
  viewAttachs(item) {
    if (item && item.attachValue && item.attachValue.length) {
      viewDocument(item.attachValue, item.attachValue[0], this.dialog);
    }
    else {
      this.notification.error('EXTINFO.no_attachments_to_view', 'CLose', 5000)
    }
  }
  deleteField(index) {
    this.dialog
      .open(ConfirmationComponent, {
        width: "480px",
        height: "auto",
        panelClass: "icr-dialog",
        data: {
          title: "ERROR.confirmation",
          message: "CONFIRMATION.are_you_sure_to_delete",
          positive_button: "BTN.yes",
          negative_button: "BTN.no"
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.data.splice(index, 1)
          this.data = [...this.data];
        }
      });
  }

  addField() {
    if (this.fieldForm.valid && this.uploadedStatus) {
      this.isEdit = 0;
      if (this.data && this.data.length) {
        let index = this.data.findIndex(data => data.fieldCode == this.fieldForm.value.fieldCode);
        if (index > -1) {
          this.data[index] = this.fieldForm.value;
        }
        else {
          this.data.push(this.fieldForm.value);
        }
      }
      else {
        this.data = [this.fieldForm.value];
      }
      this.fieldForm.reset();
      this.currentField = {}
    }
    else {
      if (!this.uploadedStatus) {
        this.notification.error('ERROR.please_wait_while_attachments_being_uploaded', 'Close', 5000)
      }
      else {
        this.notification.error('ERROR.please_fill_mandatory_fields', 'Close', 5000)
      }
    }
  }
  openUrl() {
    // let link = document.createElement('a');
    // link.setAttribute('type', 'hidden');
    // link.target = "_blank"
    // link.href = this.sellerForm.value.website;
    // // link.download = path;
    // document.body.appendChild(link);
    // link.click();
    // link.remove();
    if (this.fieldForm.value.value && this.fieldForm.value.value != '') {
      window.open(this.fieldForm.value.value, '_blank');
    }
    else {
      this.notification.error('EXTINFO.invalid_url', 'Close', 5000)
    }
  }
}
